import React from 'react'

const About = () => {
    return (
        <div  style={{textAlign:"center",marginBottom:"250px"}} >
            <h2 style={{marginTop:"200px"}}>بهترین سایت برای یادگیری آسون برنامه نویسی به هر زبانی</h2>
        </div>
    )
}

export default About
